<template>
    <add-post v-bind="commentProps"
              :parent-id="parentId"
              :place-holder-text="placeHolderText"
              :comment-count="commentCountValue"
              :show-comments-for-all-networks="true">
    </add-post>
</template>

<script>
    import AddPost from '../AddPost/AddPost';
    import { communityCommonConstant } from '../communityCommon.constant';

    export default {
        name: 'AddComment',
        data: () => ({
            commentProps: {
                canUploadImage: false,
                submitBtnText: communityCommonConstant.post.COMMENT,
                showCommentPlaceholder: true,
                showAllowCommentOption: false,
            },
        }),       
        props: {
            parentId: {
                type: String,
                required: true,
            },
            commentCountValue: {
                type: Number,
                required: true,                
            },
        },
        computed: {         
            placeHolderText() {
                return this.commentCountValue > 0
                    ? communityCommonConstant.commented_Users.Add_Comment
                    : communityCommonConstant.commented_Users.Be_The_First;
            },       
        },
        components: {
            AddPost,
        },
    };
</script>
